import axios from "axios";

export default {
  namespaced: true,
  state: {
    auth: {
      userId: "",
      token: "",
      expiryDate: "",
    },
  },
  getters: {
    auth(state) {
      return state.auth;
    },
  },
  mutations: {
    setAuthentication(state, payload) {
      const { userId, token, expiryDate } = payload;
      state.auth.userId = userId;
      state.auth.token = token;
      state.auth.expiryDate = expiryDate;
    },

    unsetAuthentication(state) {
      state.auth.userId = "";
      state.auth.token = "";
    },
  },
  actions: {
    async registerForm(context, payload) {
      try {
        const response = await axios.post("/auth/register", payload);
        return response.data;
      } catch (error) {
        throw error.response.data;
      }
    },

    async loginForm(context, payload) {
      try {
        const response = await axios.post("/auth/login", payload);
        if(response && response.data){
          await context.dispatch("setLocalStorage", response.data);
          context.dispatch("getLocalStorage");
          return response.data;
        }else{
          return;
        }
      } catch (error) {
        throw error.response.data;
      }
    },

    async forgotPasswordForm(context, payload){
      try {
        const response = await axios.put("/auth/forgot-password", payload);
        return response.data;
      } catch (error) {
        throw error.response.data;
      }
    },


    async resetPasswordForm(context, payload){
      try {
        const response = await axios.put("/auth/reset-password", payload);
        return response.data;
      } catch (error) {
        throw error.response;
      }
    },

    async checkResetTokenValidty(context, payload){
      try {
        const response = await axios.post("/auth/reset-token-validity", payload);
        return response.data;
      } catch (error) {
        throw error.response.data;
      }      
    },

    async activateAccountForm(context, payload){
      try {
        const response = await axios.post("/auth/activate-account", payload);
        return response.data;
      } catch (error) {
        throw error.response.data;
      }      
    },

    async requestActivationCodeForm(context, payload){
      try {
        const response = await axios.post("/auth/activate-code", payload);
        return response.data;
      } catch (error) {
        throw error.response.data;
      }      
    },

    logoutForm(context) {
      context.dispatch("removeLocalStorage");
    },


    // LOCAL STORAGE AND JSON WEB TOKENS

    refreshToken(context) {
      context.dispatch("getLocalStorage");
    },

    setLocalStorage(context, payload) {
      return new Promise((resolve) => {
        const { userId, token } = payload;
        localStorage.setItem("userId", userId);
        localStorage.setItem("token", token);
        const expiryDate = new Date( new Date().getTime() + (60 * 60 * 1000) );
        localStorage.setItem("expiryDate", expiryDate);
        resolve(true);
      });
    },

    getLocalStorage(context) {
      const auth = {
        userId: localStorage.getItem("userId"),
        token: localStorage.getItem("token"),
        expiryDate: localStorage.getItem("expiryDate"),
      };
      if (auth.token && auth.token && new Date() <= new Date(auth.expiryDate)) {
        const remainingMilliseconds = new Date(auth.expiryDate).getTime() - new Date().getTime();
        context.commit("setAuthentication", auth);
        setTimeout(() => {
          context.dispatch("removeLocalStorage");
        }, remainingMilliseconds);
      } else {
        context.dispatch("removeLocalStorage");
      }
    },

    removeLocalStorage(context) {
      localStorage.removeItem("userId");
      localStorage.removeItem("token");
      localStorage.removeItem("expiryDate");
      context.commit("unsetAuthentication");
    },
  },

};
